import { Component } from '@angular/core';
import { Router } from '@angular/router';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    template: ""
})
export class BlankComponent {
    constructor(
        private router: Router
    ) {
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/blank.component.ts